
import VideoPlayer from '../ui/VideoPlayer.vue'
import LandingPageCard from '@/components/ui/LandingPageCard.vue'

export default {
  components: { LandingPageCard, VideoPlayer },
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
